import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesConsulate = {
  code: '',
  page: 0,
  rowsPerPage: 10,
  orders: {},
};

const PageConsulateListInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesConsulate}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageConsulateListInitializer.displayName = 'Page Consulate List initializer component';

export default PageConsulateListInitializer;
